module.exports = __webpack_public_path__ + "static/media/main14.2fbee802.png";